var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"300px","height":"200px","margin-top":"20px"},attrs:{"id":_vm.no}})}
var staticRenderFns = []

export { render, staticRenderFns }